import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.array.is-array";

var isDisabled = function isDisabled(props) {
  return props.disabled || Array.isArray(props.accessibilityStates) && props.accessibilityStates.indexOf('disabled') > -1;
};

export default isDisabled;